export abstract class AbstractRoleProvider {
  public abstract getRoles(): Promise<Array<string>>;
}
